'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardLoginsResponse(total, errors, rate, hosts, hostStats, systemStats, topUsers, topAccounts, sign) {
  this.xA = 0;
  this.Ed = 0;
  this.Ef = 0.0;
  this.Ee = null;
  this.xy = null;
  this.xz = null;
  this.Ei = null;
  this.Eh = null;
  this.Eg = null;
  this.xA = total;
  this.Ed = errors;
  this.Ef = rate;
  this.Ee = hosts;
  this.xy = hostStats;
  this.xz = systemStats;
  this.Ei = topUsers;
  this.Eh = topAccounts;
  this.Eg = sign;
}
export { $c_Lpresto_types$DashboardLoginsResponse as $c_Lpresto_types$DashboardLoginsResponse };
$p = $c_Lpresto_types$DashboardLoginsResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardLoginsResponse;
/** @constructor */
function $h_Lpresto_types$DashboardLoginsResponse() {
}
export { $h_Lpresto_types$DashboardLoginsResponse as $h_Lpresto_types$DashboardLoginsResponse };
$h_Lpresto_types$DashboardLoginsResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardLoginsResponse"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.xA);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.Ed);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().h7(this.Ef));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Ee));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xy));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xz));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Ei));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Eh));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Eg));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 9);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$DashboardLoginsResponse)) {
    if ((((this.xA === x$0.xA) && (this.Ed === x$0.Ed)) && (this.Ef === x$0.Ef))) {
      var x = this.Ee;
      var x$2 = x$0.Ee;
      var $x_5 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3 = this.xy;
      var x$4 = x$0.xy;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.xz;
      var x$6 = x$0.xz;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Ei;
      var x$8 = x$0.Ei;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Eh;
      var x$10 = x$0.Eh;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.Eg;
      var x$12 = x$0.Eg;
      return ((x$11 === null) ? (x$12 === null) : x$11.i(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 9;
});
$p.s = (function() {
  return "DashboardLoginsResponse";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.xA;
      break;
    }
    case 1: {
      return this.Ed;
      break;
    }
    case 2: {
      return this.Ef;
      break;
    }
    case 3: {
      return this.Ee;
      break;
    }
    case 4: {
      return this.xy;
      break;
    }
    case 5: {
      return this.xz;
      break;
    }
    case 6: {
      return this.Ei;
      break;
    }
    case 7: {
      return this.Eh;
      break;
    }
    case 8: {
      return this.Eg;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$DashboardLoginsResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jL)));
}
export { $isArrayOf_Lpresto_types$DashboardLoginsResponse as $isArrayOf_Lpresto_types$DashboardLoginsResponse };
var $d_Lpresto_types$DashboardLoginsResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardLoginsResponse, "presto.types$DashboardLoginsResponse", ({
  jL: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardLoginsResponse as $d_Lpresto_types$DashboardLoginsResponse };
//# sourceMappingURL=presto.types$-Dashboard-Logins-Response.js.map
